module.exports = __FOREMAN_VENDOR__REACT_ACE__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_ACE__"
// module id = react-ace
// module chunks = 0 1 2